
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.504 15.744a3.386 3.386 0 01-2.054-3.127 3.498 3.498 0 011.687-2.947 1 1 0 00.3-1.415 5.574 5.574 0 00-4.016-2.385 6.422 6.422 0 00.965-3.977.984.984 0 00-1.034-.892 6.69 6.69 0 00-4.443 2.261 6.84 6.84 0 00-1.48 2.9 5.264 5.264 0 00-1.62-.278 5.925 5.925 0 00-4.99 3.008c-1.888 3.277-.733 8.189 1.312 11.145C5.95 21.22 7.182 23 9.039 23c.037 0 .074 0 .11-.003a4.741 4.741 0 001.793-.463 3.273 3.273 0 011.446-.354c.472.006.937.122 1.357.338.614.29 1.283.446 1.962.456 1.913-.036 3.043-1.686 3.868-2.893a12.04 12.04 0 001.513-3.108 1.003 1.003 0 00-.584-1.23zm-7.08-11.176a4.941 4.941 0 011.919-1.322 4.856 4.856 0 01-1.037 2.151 4.39 4.39 0 01-1.264 1.04l-.003.001-.085.034c-.187.073-.417.164-.595.223a4.826 4.826 0 011.064-2.127zm4.5 14.385c-.803 1.174-1.435 2.006-2.254 2.021a2.366 2.366 0 01-1.131-.292 4.97 4.97 0 00-2.151-.502 5.214 5.214 0 00-2.229.513 2.885 2.885 0 01-1.086.306h-.03c-.813 0-1.687-1.262-2.268-2.101-1.452-2.1-2.792-6.283-1.223-9.008a3.917 3.917 0 013.29-2.006h.034c.57.048 1.126.198 1.642.444.13.051.26.103.389.151.032.014.066.026.1.037.356.143.734.224 1.117.237a4.437 4.437 0 001.564-.42 4.956 4.956 0 012.223-.498 3.787 3.787 0 012.25.854 5.31 5.31 0 00-1.711 3.945v.001a5.302 5.302 0 002.45 4.503c-.262.636-.59 1.244-.975 1.815z","fill":"currentColor"}})])
          )
        }
      }
    